import { useContext, useEffect, useRef, useState } from "react";
import { Video, X } from "lucide-react";
import { NotifCtx } from "@/components/Notifications";
import { useProfile } from "@/context/ProfileContext";
import { chime } from "@/lib/chime";

const SEEN = "cl_class_popups", GONE = "cl_class_popups_hidden";

export const ClassPopup = () => {
  const { banner } = useContext(NotifCtx);
  const { profile } = useProfile();
  const [hidden, setHiddenState] = useState(() => JSON.parse(sessionStorage.getItem(GONE) || "[]"));
  const setHidden = (f) => setHiddenState((h) => { const n = f(h); sessionStorage.setItem(GONE, JSON.stringify(n)); return n; });
  const rung = useRef(new Set(JSON.parse(sessionStorage.getItem(SEEN) || "[]")));
  const list = banner.filter((b) => b.school && !hidden.includes(`${b.class_id}:${b.kid_id}`));
  useEffect(() => {
    const fresh = list.filter((b) => !rung.current.has(`${b.class_id}:${b.kid_id}`));
    if (!fresh.length) return;
    fresh.forEach((b) => rung.current.add(`${b.class_id}:${b.kid_id}`));
    sessionStorage.setItem(SEEN, JSON.stringify([...rung.current]));
    chime(0.7);
  }, [list]);
  if (!list.length) return null;
  const parent = profile?.role === "parent";
  return (
    <div className="fixed top-20 right-4 left-4 sm:left-auto sm:w-[360px] z-40 space-y-2" data-testid="class-popup">
      {list.slice(0, 2).map((b) => (
        <div key={`${b.class_id}:${b.kid_id}`} className="rise rounded-2xl bg-[#2C4A3E] text-[#F7F3EB] p-4 shadow-[0_16px_40px_rgba(31,61,51,0.35)]" data-testid={`class-popup-${b.class_id}`}>
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 rounded-xl bg-[#F28C38] text-[#3B1D05] grid place-items-center shrink-0"><Video className={`w-5 h-5 ${b.status === "live" ? "animate-pulse" : ""}`} /></span>
            <div className="flex-1 min-w-0">
              <p className="text-xs uppercase tracking-widest text-[#F2D49B]">{b.status === "live" ? "Live now" : `Class starts in ${b.minutes} min`}</p>
              <p className="font-medium break-words">{parent ? `${b.kid_name}: ` : ""}{b.topic}</p>
              {b.course && <p className="text-xs text-[#F7F3EB]/70">{b.course}</p>}
            </div>
            <button onClick={() => setHidden((h) => [...h, `${b.class_id}:${b.kid_id}`])} aria-label="Dismiss" data-testid={`class-popup-dismiss-${b.class_id}`} className="opacity-70 hover:opacity-100"><X className="w-4 h-4" /></button>
          </div>
          <a href={b.join_url} target="_blank" rel="noreferrer" data-testid={`class-popup-join-${b.class_id}`}
            className="mt-3 block text-center px-5 py-2.5 rounded-full bg-[#F2D49B] text-[#5B3A1E] text-sm font-semibold hover:scale-[1.02] transition-transform">{parent ? `Open ${b.kid_name}'s class` : "Join now"}</a>
        </div>
      ))}
    </div>
  );
};
